import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

;(function (_, $) {
  $(document).ready(function() {
    const phoneInput = document.querySelector('#phone');
    
    if (phoneInput) {
      // Store the instance globally for form validation and submission
      phoneInput.iti = intlTelInput(phoneInput, {
        loadUtils: () => import("intl-tel-input/utils"),
        initialCountry: "auto",
        geoIpLookup: callback => {
          fetch("https://ipapi.co/json")
            .then(res => res.json())
            .then(data => callback(data.country_code))
            .catch(() => callback("us"));
        },
        containerClass: "dn:w-full",
        utilsScript: null,
      });
    }
  });
})(window, jQuery);
